import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import backBtn from "../../assets/images/backBtn.svg";
import {
  EducationalThankYouYes,
  EducationalThankYouNo,
} from "./EducationalComponents";
import EducationalContentHeader from "./EducationalContentHeader";

const EducationalContentThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const enrollmentDecision = location.state?.enrollmentDecision?.toUpperCase();
  useEffect(() => {
    if (!enrollmentDecision) {
      navigate("/guest-user/enrollment", { replace: true });
    }
  }, [enrollmentDecision, navigate]);

  const handleBack = () => {
    if (enrollmentDecision === "NO") {
      navigate("/guest-user/enrollment");
    } else {
      navigate("/guest-user/esign", {
        state: { enrollmentDecision: "YES" },
      });
    }
  };

  const onChangeDecision = () => {
    navigate("/guest-user/enrollment", { state: { enrollmentDecision: null } });
  };

  if (!enrollmentDecision) {
    return null;
  }

  return (
    <EducationalContentHeader
      backBtnSrc={backBtn}
      backBtnMobileSrc={backBtnMobile}
      onBack={handleBack}
      title={t("Thank You")}
      hideNavigation
      hideBackButton={true}
    >
      <div className="stepperview mb-40">
        {enrollmentDecision === "YES" ? (
          <EducationalThankYouYes onChangeDecision={onChangeDecision} />
        ) : (
          <EducationalThankYouNo onChangeDecision={onChangeDecision} />
        )}
      </div>
    </EducationalContentHeader>
  );
};

export default EducationalContentThankYou;
